import { isAbsoluteHref, isNextJsPath } from '@ifixit/helpers';
import { isStoreLocaleCode } from '@ifixit/i18n/helpers';
import { LocaleCode } from '@ifixit/i18n/types';
import { useStoreLocale } from '@ifixit/i18n/hooks';
import type { ComponentPropsWithoutRef, Ref } from 'react';

type SmartLinkProps = ComponentPropsWithoutRef<'a'>;

export function SmartLink({
   ref,
   href,
   ...other
}: SmartLinkProps & { ref?: Ref<HTMLAnchorElement> }) {
   const storeLocale = useStoreLocale();
   if (!href) {
      return null;
   }
   const localizedHref = localizeUrl(href, storeLocale);

   return <a ref={ref} href={localizedHref.toString()} {...other} />;
}

function localizeUrl(url: string, storeLocale: LocaleCode): URL | string {
   // we don't need to localize us links or absolute links
   // this doesn't localize non-nextjs paths
   if (!storeLocale || isAbsoluteHref(url) || !isNextJsPath(url)) {
      return url;
   }

   if (storeLocale === 'en-us') {
      return new URL(url, App.baseiFixitOrigin);
   }

   const subPaths = url.split('/').filter(Boolean);
   const firstSubDir = subPaths.shift();
   if (firstSubDir) {
      if (!isStoreLocaleCode(firstSubDir)) {
         subPaths.unshift(firstSubDir);
      }
      subPaths.unshift(storeLocale);
   }

   return new URL(subPaths.join('/'), App.baseiFixitOrigin);
}
